import Cookie from "../../save/Cookie.js";
import axios from "axios";
import { mapGetters } from "vuex";

const mixin = {
  created() {
    switch (location.pathname.split("/")[1]) {
      case "user":
        this.getGlobalData();
        break;
      default:
        this.getInitData();
        break;
    }
    this.setCookie();
  },
  metaInfo() {
    const title = this.title;
    return {
      title: title,
    };
  },
  mounted: function () {
    setTimeout(() => {
      this.$i18n.locale = Cookie.get("lang") || "ko";
      const html_dom = document.querySelector("html");
      html_dom.lang = Cookie.get("lang") || "ko";
    }, 0);
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({
      title: "project/getTitle",
      gnb_design: "project/getGnbDesign",
    }),
  },
  watch: {
    title: {
      handler() {
        document.title = this.title;
      },
      immediate: true,
    },
  },
  methods: {
    getGlobalData() {
      axios.get("/global-data").then((res) => {
        if (Object.keys(res.data).length > 0) {
          this.$store.commit(
            "project/setGnbDesign",
            res.data.setting.set_favicon
          );
          this.$store.commit("setSetting", res.data.setting);
          this.$store.commit("setCookie", res.data.cookie);
        }
      });
    },
    getInitData() {
      axios.get("/init-data").then((res) => {
        if (Object.keys(res.data).length > 0) {
          this.$store.commit(
            "project/setGnbDesign",
            res.data.setting.set_favicon
          );
          this.$store.commit("setSetting", res.data.setting);
          this.$store.commit("setUserId", res.data.user_id);
          this.$store.commit("setUserName", res.data.user_name);
          this.$store.commit("setUserTel", res.data.user_tel);
          this.$store.commit("setUserMail", res.data.user_mail);
          this.$store.commit("setIsSuperuser", res.data.is_superuser);
          this.$store.commit("setCookie", res.data.cookie);
          this.$store.commit("setTimezone", res.data.timezone);
        }
      });
    },
    setCookie() {
      setTimeout(() => {
        const theme = Cookie.get("theme") || "white";

        switch (theme) {
          case ("black", "dark"):
            this.$store.commit("setColorMode", "dark");
            break;
          case ("white", "light"):
            this.$store.commit("setColorMode", "light");
            break;
          default:
            this.$store.commit("setColorMode", "light");
            break;
        }
      }, 0);
    },
  },
};

export default mixin;
